export default {
	GROUP: 1,
	PATIENT: 2,
	DEVICE: 3
}



// WEBPACK FOOTER //
// ./src/components/user/watches/FormTypes.js